<div class="card">
  <div class="body">
    <svg
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M32 0C14.336 0 0 14.336 0 32C0 49.664 14.336 64 32 64C49.664 64 64 49.664 64 32C64 14.336 49.664 0 32 0ZM35.2 48H28.8V41.6H35.2V48ZM35.2 35.2H28.8V16H35.2V35.2Z"
        fill="#FF1A1A"
      />
    </svg>

    <div class="data">
      <div class="title">
        {{ data?.title }}
      </div>

      <div class="description">
        {{ data?.detail }}
      </div>
    </div>

    <div class="field full">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>รหัสผ่าน</mat-label>

        <input
          matInput
          [(ngModel)]="password"
          [type]="hidePassword ? 'password' : 'text'"
          placeholder="โปรดกรอกรหัสผ่าน"
        />

        <button
          mat-icon-button
          matSuffix
          type="button"
          (click)="hidePassword = !hidePassword"
        >
          <mat-icon>
            {{ hidePassword ? "visibility_off" : "visibility" }}
          </mat-icon>
        </button>
      </mat-form-field>
    </div>

    <div class="actions">
      <button mat-stroked-button class="btn-danger" (click)="cancel()">
        {{ "view_value.cancel" | translate }}
      </button>

      <button mat-stroked-button class="btn-outline-danger" (click)="agree()">
        {{ "view_value.confirm" | translate }}
      </button>
    </div>
  </div>
</div>
